import _ from 'lodash'
import { useParams } from 'react-router-dom'

import {
  LoadingContainer,
  Modal,
  Input,
  Model,
  Bar,
  Panels,
  Pagination,
} from 'peach/components'
import {
  CompanyEmployeeSelect,
  CompanyAgentUserSelect,
} from 'peach/scopes/company'

import Dialog from 'core/components/lib/Dialog'
import { useQueryString } from 'core/hooks'
import { Page } from 'core/components'
import {
  useInternalEmployeesGet,
  useInternalEmployeeCreate,
  PickRequired,
} from 'core/types'
import { InternalEmployeesGetVariables } from 'core/types/operations'

import AddEmployeeForm from './AddEmployeeForm'

const CompanyPeople = () => {
  const { companyId } = useParams()

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<InternalEmployeesGetVariables['query']>,
      'limit' | 'offset'
    >
  >({
    limit: 50,
    offset: 0,
  })

  const {
    data: employees,
    pagination: { total: count } = {},
    isLoading,
    error,
    refetch,
  } = useInternalEmployeesGet({
    companyId,
    query,
  })

  const { mutateAsync: addCompanyEmployee } = useInternalEmployeeCreate({
    companyId,
  })

  // Wrapper component that handles both form submission success and dialog closing
  const AddEmployeeFormWithRefetch = ({
    onSuccess,
  }: {
    onSuccess?: () => void
  }) => {
    const handleSuccess = async () => {
      await refetch() // Refetch the employees data
      onSuccess?.() // Close the dialog
    }

    return <AddEmployeeForm onSuccess={handleSuccess} />
  }

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              maxPagesVisible={16}
              offset={query.offset ?? 0}
              onChange={(offset) => setQuery({ offset })}
              total={count}
            />
          }
          right={
            <>
              <Dialog
                content={<AddEmployeeFormWithRefetch />}
                heightContainer='large'
                title='Add User + Employee'
              />
              <Modal
                onSubmit={async (newEmployee) => {
                  await addCompanyEmployee(newEmployee)
                  await refetch()
                }}
                title='Add Employee'
              >
                <Input formKey='firstName' />
                <Input formKey='lastName' />
                <Input formKey='jobName' />
                <CompanyAgentUserSelect
                  formKey='userId'
                  label='User'
                  nullable
                />
                <CompanyEmployeeSelect
                  formKey='managerEmployeeId'
                  label='Manager Employee'
                  nullable
                />
              </Modal>
            </>
          }
          title='Employees'
        />
      }
    >
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          <Model.List
            json={_.sortBy(employees, 'createdAt').reverse()}
            title='Employees'
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default CompanyPeople
